/*!
 * Copyright © 2025. Verizon Connect Ireland Limited. All rights reserved.
 */

import { Pipe, PipeTransform } from '@angular/core';
import { EnumUtilities } from '../../../../utils/enum.utilities';
import { DeviceHealthErrorCode } from '../../../core/models/device-health-error.enum';

@Pipe({
  name: 'deviceHealthErrorLocalizePipe',
  standalone: true
})
export class DeviceHealthErrorLocalizePipe implements PipeTransform {
  transform(value: string | null): string | null {
    if (!value || !EnumUtilities.isValidEnumValue(value, DeviceHealthErrorCode)) {
      return null;
    }

    return this._mapToLocalizedErrorString(value);
  }

  private _mapToLocalizedErrorString(input: DeviceHealthErrorCode): string {
    let localizedString: string = input;

    switch (input) {
      case DeviceHealthErrorCode.FalseTowing:
        localizedString = $localize`:@@S_FLEET_DEVICE_LIST_DEVICE_ERRORS_TYPE_FALSE_TOWING:Incorrect towing status`;
        break;
      case DeviceHealthErrorCode.NoMessage:
        localizedString = $localize`:@@S_FLEET_DEVICE_LIST_DEVICE_ERRORS_TYPE_NO_MESSAGE:No message`;
        break;
      case DeviceHealthErrorCode.NonReportingUnit:
        localizedString = $localize`:@@S_FLEET_DEVICE_LIST_DEVICE_ERRORS_TYPE_NON_REPORTING_UNIT:Tracker not reporting`;
        break;
      case DeviceHealthErrorCode.SDCardError:
        localizedString = $localize`:@@S_FLEET_DEVICE_LIST_DEVICE_ERRORS_TYPE_SD_CARD_ERROR:SD card error`;
        break;
      case DeviceHealthErrorCode.VideosNotAvailable:
        localizedString = $localize`:@@S_FLEET_DEVICE_LIST_DEVICE_ERRORS_TYPE_VIDEO_NOT_AVAILABLE:Videos are not available`;
        break;
      case DeviceHealthErrorCode.IncompleteInstallation:
        localizedString = $localize`:@@S_FLEET_DEVICE_LIST_DEVICE_ERRORS_TYPE_INCOMPLETE_INSTALLATION:Incomplete installation`;
        break;
      case DeviceHealthErrorCode.VideoFileIssue:
        localizedString = $localize`:@@S_FLEET_DEVICE_LIST_DEVICE_ERRORS_TYPE_VIDEO_FILE_ISSUE:Video file issue`;
        break;
      case DeviceHealthErrorCode.MediaErrorLastWeek:
        localizedString = $localize`:@@S_FLEET_DEVICE_LIST_DEVICE_ERRORS_TYPE_MEDIA_ERROR_LAST_WEEK:Media error last week`;
        break;
      case DeviceHealthErrorCode.MediaErrorYesterday:
        localizedString = $localize`:@@S_FLEET_DEVICE_LIST_DEVICE_ERRORS_TYPE_MEDIA_ERROR_YESTERDAY:SD card error Dashcam`;
        break;
      case DeviceHealthErrorCode.TiltedGsensor:
        localizedString = $localize`:@@S_FLEET_DEVICE_LIST_DEVICE_ERRORS_TYPE_TILTED_G_SENSOR:Tilted G sensor`;
        break;
      case DeviceHealthErrorCode.NoMsgFromCam:
        localizedString = $localize`:@@S_FLEET_DEVICE_LIST_DEVICE_ERRORS_TYPE_NO_MSG_FROM_CAM:Camera not reporting`;
        break;
      case DeviceHealthErrorCode.HighTowingFrequency:
        localizedString = $localize`:@@S_FLEET_DEVICE_LIST_DEVICE_ERRORS_TYPE_HIGH_TOWING_FREQUENCY:High towing frequency`;
        break;
      case DeviceHealthErrorCode.RoadCameraVerticallyMisaligned:
        localizedString = $localize`:@@S_FLEET_DEVICE_LIST_DEVICE_ERRORS_TYPE_ROAD_CAMERA_VERTICALLY_MISALIGNED:Road camera vertically misaligned`;
        break;
      case DeviceHealthErrorCode.MediaErrorYesterdayDvr:
        localizedString = $localize`:@@S_FLEET_DEVICE_LIST_DEVICE_ERRORS_TYPE_MEDIA_ERROR_YESTERDAY_DVR:SD card error EVC`;
        break;
      case DeviceHealthErrorCode.NomsgFromDvr:
        localizedString = $localize`:@@S_FLEET_DEVICE_LIST_DEVICE_ERRORS_TYPE_NO_MESSAGE_FROM_DVR:DVR not reporting`;
        break;
    }

    return localizedString;
  }
}
